import React from 'react'

import './feedbackheader.scss'

export function FeedbackHeader({ pretitle = 'PEP Opinion - ', title }) {
  return (
    <header className='feedback-header'>
      <span className='logo'>
        <img alt='Invison360 QA Module Logo' src='/qa-logo-light.svg' />
      </span>
      <h1>
        {pretitle}
        {title}
      </h1>
    </header>
  )
}
